import 'svelte/internal/disclose-version';

Login[$.FILENAME] = 'src/pages/Login.svelte';

import * as $ from 'svelte/internal/client';
import Field from "../components/Field.svelte";
import api from "../lib/api.js";
import { session, setUser } from "../lib/session.svelte.js";
import { navigate, route } from "../lib/router.svelte.js";
import { toastSuccess, toastError } from "../lib/toast.svelte.js";

var root = $.add_locations($.from_html(`<p class="error banner svelte-1428x5h">Google sign-in didn't complete. Try again, or use your email below.</p>`), Login[$.FILENAME], [[50, 6]]);

var root_1 = $.add_locations($.from_html(`<a class="google svelte-1428x5h" href="/api/auth/google/login" data-native=""><svg viewBox="0 0 24 24" aria-hidden="true" class="svelte-1428x5h"><path fill="#4285F4" d="M21.6 12.2c0-.7-.1-1.4-.2-2H12v3.8h5.4a4.6 4.6 0 0 1-2 3v2.5h3.2c1.9-1.7 3-4.3 3-7.3Z"></path><path fill="#34A853" d="M12 22c2.7 0 5-.9 6.6-2.5l-3.2-2.5c-.9.6-2 1-3.4 1-2.6 0-4.8-1.8-5.6-4.1H3.1v2.6A10 10 0 0 0 12 22Z"></path><path fill="#FBBC05" d="M6.4 13.9a6 6 0 0 1 0-3.8V7.5H3.1a10 10 0 0 0 0 9l3.3-2.6Z"></path><path fill="#EA4335" d="M12 5.9c1.5 0 2.8.5 3.8 1.5l2.8-2.8A10 10 0 0 0 3.1 7.5l3.3 2.6C7.2 7.7 9.4 5.9 12 5.9Z"></path></svg> Continue with Google</a> <div class="or svelte-1428x5h"><span>or</span></div>`, 1), Login[$.FILENAME], [
	[54, 6, [[55, 8, [[56, 10], [57, 10], [58, 10], [59, 10]]]]],
	[63, 6, [[63, 22]]]
]);

var root_2 = $.add_locations($.from_html(`<button type="button" class="link svelte-1428x5h">Send a new confirmation link</button>`), Login[$.FILENAME], [[74, 12]]);
var root_3 = $.add_locations($.from_html(`<p class="error svelte-1428x5h"> <!></p>`), Login[$.FILENAME], [[71, 8]]);

var root_4 = $.add_locations($.from_html(`<div class="auth svelte-1428x5h"><div class="card svelte-1428x5h"><h1 class="svelte-1428x5h">Welcome back</h1> <p class="sub svelte-1428x5h">Log in to keep your list and reviews in one place.</p> <!> <!> <form class="svelte-1428x5h"><!> <!> <!> <button class="primary svelte-1428x5h" type="submit"> </button></form> <div class="links svelte-1428x5h"><a href="/forgot-password" class="svelte-1428x5h">Forgot your password?</a> <span>New here? <a href="/register" class="svelte-1428x5h">Create an account</a></span></div></div></div>`), Login[$.FILENAME], [
	[
		44,
		0,
		[
			[
				45,
				2,
				[
					[46, 4],
					[47, 4],
					[66, 4, [[79, 6]]],
					[82, 4, [[83, 6], [84, 6, [[84, 22]]]]]
				]
			]
		]
	]
]);

const $$css = {
	hash: 'svelte-1428x5h',
	code: '\n  .auth.svelte-1428x5h { display: grid; place-items: center; padding: 48px 0 64px; }\n  .card.svelte-1428x5h {\n    width: min(430px, 100%);\n    background: var(--card);\n    border: 1px solid var(--line);\n    border-radius: var(--radius-lg);\n    padding: 32px;\n    box-shadow: var(--shadow);\n  }\n  h1.svelte-1428x5h { font-size: 1.7rem; }\n  .sub.svelte-1428x5h { margin: 8px 0 22px; color: var(--ink-soft); font-size: 0.94rem; }\n\n  form.svelte-1428x5h { display: flex; flex-direction: column; gap: 14px; }\n  .primary.svelte-1428x5h {\n    margin-top: 4px;\n    background: var(--accent);\n    color: #fff;\n    border: none;\n    font-weight: 600;\n    font-size: 0.96rem;\n    padding: 13px;\n    border-radius: var(--radius-pill);\n    cursor: pointer;\n  }\n  .primary.svelte-1428x5h:hover:not(:disabled) { background: var(--accent-dark); }\n  .primary.svelte-1428x5h:disabled { opacity: 0.6; cursor: progress; }\n\n  .google.svelte-1428x5h {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    border: 1px solid var(--line-strong);\n    border-radius: var(--radius-pill);\n    padding: 12px;\n    font-weight: 600;\n    font-size: 0.94rem;\n    background: var(--card);\n  }\n  .google.svelte-1428x5h:hover { border-color: var(--accent); }\n  .google.svelte-1428x5h svg:where(.svelte-1428x5h) { width: 19px; height: 19px; }\n\n  .or.svelte-1428x5h {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin: 18px 0;\n    color: var(--ink-faint);\n    font-size: 0.82rem;\n  }\n  .or.svelte-1428x5h::before, .or.svelte-1428x5h::after { content: ""; flex: 1; height: 1px; background: var(--line); }\n\n  .error.svelte-1428x5h { margin: 0; color: var(--accent-dark); font-size: 0.87rem; line-height: 1.5; }\n  .error.banner.svelte-1428x5h {\n    background: var(--accent-soft);\n    padding: 10px 14px;\n    border-radius: var(--radius-sm);\n    margin-bottom: 16px;\n  }\n  .link.svelte-1428x5h {\n    display: block;\n    border: none;\n    background: none;\n    color: var(--accent);\n    font-weight: 600;\n    padding: 4px 0 0;\n    cursor: pointer;\n    text-decoration: underline;\n    font-size: 0.87rem;\n  }\n\n  .links.svelte-1428x5h {\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    font-size: 0.88rem;\n    color: var(--ink-soft);\n  }\n  .links.svelte-1428x5h a:where(.svelte-1428x5h) { color: var(--accent); font-weight: 600; }\n  .links.svelte-1428x5h a:where(.svelte-1428x5h):hover { text-decoration: underline; }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function Login($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Login);
	$.append_styles($$anchor, $$css);

	let email = $.tag($.state(""), 'email');
	let password = $.tag($.state(""), 'password');
	let busy = $.tag($.state(false), 'busy');
	let error = $.tag($.state(""), 'error');
	let unverified = $.tag($.state(false), 'unverified');
	const urlError = $.tag($.derived(() => route.query.get("error")), 'urlError');

	async function submit(event) {
		event.preventDefault();
		$.set(error, "");
		$.set(unverified, false);
		$.set(busy, true);

		try {
			const response = (await $.track_reactivity_loss(api.login({ email: $.get(email).trim(), password: $.get(password) })))();

			(await $.track_reactivity_loss(setUser(response.user)))();
			toastSuccess(`Welcome back, ${response.user.displayName.split(" ")[0]}!`);
			navigate("/");
		} catch(e) {
			$.set(error, e.message ?? "That didn't work.", true);
			$.set(unverified, $.strict_equals(e.detail, "email_unverified"));
		} finally {
			$.set(busy, false);
		}
	}

	async function resend() {
		try {
			(await $.track_reactivity_loss(api.resendVerification($.get(email).trim())))();
			toastSuccess("New confirmation link sent.");
		} catch(e) {
			toastError(e.message ?? "Couldn't send that.");
		}
	}

	var $$exports = { ...$.legacy_api() };
	var div = root_4();
	var div_1 = $.child(div);
	var node = $.sibling($.child(div_1), 4);

	{
		var consequent = ($$anchor) => {
			var p = root();

			$.append($$anchor, p);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($.get(urlError)) $$render(consequent);
			}),
			'if',
			Login,
			49,
			4
		);
	}

	var node_1 = $.sibling(node, 2);

	{
		var consequent_1 = ($$anchor) => {
			var fragment = root_1();

			$.next(2);
			$.append($$anchor, fragment);
		};

		$.add_svelte_meta(
			() => $.if(node_1, ($$render) => {
				if (session.googleEnabled) $$render(consequent_1);
			}),
			'if',
			Login,
			53,
			4
		);
	}

	var form = $.sibling(node_1, 2);
	var node_2 = $.child(form);

	$.add_svelte_meta(
		() => Field(node_2, {
			label: 'Email',
			name: 'email',
			type: 'email',
			required: true,
			autocomplete: 'email',
			placeholder: 'you@example.com',
			get value() {
				return $.get(email);
			},

			set value($$value) {
				$.set(email, $$value, true);
			}
		}),
		'component',
		Login,
		67,
		6,
		{ componentTag: 'Field' }
	);

	var node_3 = $.sibling(node_2, 2);

	$.add_svelte_meta(
		() => Field(node_3, {
			label: 'Password',
			name: 'password',
			type: 'password',
			required: true,
			autocomplete: 'current-password',
			get value() {
				return $.get(password);
			},

			set value($$value) {
				$.set(password, $$value, true);
			}
		}),
		'component',
		Login,
		68,
		6,
		{ componentTag: 'Field' }
	);

	var node_4 = $.sibling(node_3, 2);

	{
		var consequent_3 = ($$anchor) => {
			var p_1 = root_3();
			var text = $.child(p_1);
			var node_5 = $.sibling(text);

			{
				var consequent_2 = ($$anchor) => {
					var button = root_2();

					$.delegated('click', button, resend);
					$.append($$anchor, button);
				};

				$.add_svelte_meta(
					() => $.if(node_5, ($$render) => {
						if ($.get(unverified)) $$render(consequent_2);
					}),
					'if',
					Login,
					73,
					10
				);
			}

			$.reset(p_1);
			$.template_effect(() => $.set_text(text, `${$.get(error) ?? ''} `));
			$.append($$anchor, p_1);
		};

		$.add_svelte_meta(
			() => $.if(node_4, ($$render) => {
				if ($.get(error)) $$render(consequent_3);
			}),
			'if',
			Login,
			70,
			6
		);
	}

	var button_1 = $.sibling(node_4, 2);
	var text_1 = $.child(button_1, true);

	$.reset(button_1);
	$.reset(form);
	$.next(2);
	$.reset(div_1);
	$.reset(div);

	$.template_effect(() => {
		button_1.disabled = $.get(busy);
		$.set_text(text_1, $.get(busy) ? "Logging in…" : "Log in");
	});

	$.event('submit', form, submit);
	$.append($$anchor, div);

	return $.pop($$exports);
}

$.delegate(['click']);